/* tslint:disable */
/* eslint-disable */
/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AddClientContact } from './AddClientContact';
import {
	AddClientContactFromJSON,
	AddClientContactFromJSONTyped,
	AddClientContactToJSON,
} from './AddClientContact';
import type { AddServiceContact } from './AddServiceContact';
import {
	AddServiceContactFromJSON,
	AddServiceContactFromJSONTyped,
	AddServiceContactToJSON,
} from './AddServiceContact';
import type { InputMethod } from './InputMethod';
import {
	InputMethodFromJSON,
	InputMethodFromJSONTyped,
	InputMethodToJSON,
} from './InputMethod';

/**
 * A payload that will create a new client organization
 * @export
 * @interface CreateClient
 */
export interface CreateClient {
	/**
	 * The internal name for the organization entity
	 * @type {string}
	 * @memberof CreateClient
	 */
	internalName: string;
	/**
	 * An optional unique identifier for the entity that may be provided from an external system
	 * @type {string}
	 * @memberof CreateClient
	 */
	uniqueIdentifier?: string;
	/**
	 * A URI value that typically starts with the "sharefile" schema.  Segments are delimited with a "/". Segments are composed of a leaf  type and identifier that is delimited by "-".
	 *
	 * @type {string}
	 * @memberof CreateClient
	 */
	containerRID?: string;
	/**
	 * A URI value that typically starts with the "sharefile" schema.  Segments are delimited with a "/". Segments are composed of a leaf  type and identifier that is delimited by "-".
	 *
	 * @type {string}
	 * @memberof CreateClient
	 */
	metadataSchemaRID?: string;
	/**
	 *
	 * @type {object}
	 * @memberof CreateClient
	 */
	metadata?: object;
	/**
	 *
	 * @type {Array<AddClientContact>}
	 * @memberof CreateClient
	 */
	clientContacts?: Array<AddClientContact>;
	/**
	 *
	 * @type {Array<AddServiceContact>}
	 * @memberof CreateClient
	 */
	serviceContacts?: Array<AddServiceContact>;
	/**
	 *
	 * @type {InputMethod}
	 * @memberof CreateClient
	 */
	inputMethod?: InputMethod;
}

/**
 * Check if a given object implements the CreateClient interface.
 */
export function instanceOfCreateClient(value: object): boolean {
	let isInstance = true;
	isInstance = isInstance && 'internalName' in value;

	return isInstance;
}

export function CreateClientFromJSON(json: any): CreateClient {
	return CreateClientFromJSONTyped(json, false);
}

export function CreateClientFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): CreateClient {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		internalName: json['internalName'],
		uniqueIdentifier: !exists(json, 'uniqueIdentifier')
			? undefined
			: json['uniqueIdentifier'],
		containerRID: !exists(json, 'containerRID') ? undefined : json['containerRID'],
		metadataSchemaRID: !exists(json, 'metadataSchemaRID')
			? undefined
			: json['metadataSchemaRID'],
		metadata: !exists(json, 'metadata') ? undefined : json['metadata'],
		clientContacts: !exists(json, 'clientContacts')
			? undefined
			: (json['clientContacts'] as Array<any>).map(AddClientContactFromJSON),
		serviceContacts: !exists(json, 'serviceContacts')
			? undefined
			: (json['serviceContacts'] as Array<any>).map(AddServiceContactFromJSON),
		inputMethod: !exists(json, 'inputMethod')
			? undefined
			: InputMethodFromJSON(json['inputMethod']),
	};
}

export function CreateClientToJSON(value?: CreateClient | null): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		internalName: value.internalName,
		uniqueIdentifier: value.uniqueIdentifier,
		containerRID: value.containerRID,
		metadataSchemaRID: value.metadataSchemaRID,
		metadata: value.metadata,
		clientContacts:
			value.clientContacts === undefined
				? undefined
				: (value.clientContacts as Array<any>).map(AddClientContactToJSON),
		serviceContacts:
			value.serviceContacts === undefined
				? undefined
				: (value.serviceContacts as Array<any>).map(AddServiceContactToJSON),
		inputMethod: InputMethodToJSON(value.inputMethod),
	};
}
